<app-user-dashboard [fullScreen]="true">
  <div class="bg-container">
    <div class="container">
      <div class="card">
        <div class="section-info">
          <h2 class="title-card">
            {{'BenefitAndCommercialFocus.TitleCard' | translate}}
          </h2>
          <div class="section-flex">
            <div class="section-img">
              <figure class="figure-img">
                <img src="../../../../assets/img/process_fruzty/beneficio_1.png" style="width: 100%" alt="flag"/>
              </figure>
            </div>
            <p class="text-card">
              {{'BenefitAndCommercialFocus.TextCard1' | translate}}
              <span class="textColor">
                {{'BenefitAndCommercialFocus.TextCard1Main' | translate}}.
              </span>
            </p>
          </div>
          <div class="divider"></div>
          <div class="section-flex">
            <div class="section-img">
              <figure class="figure-img-pd">
                <img src="../../../../assets/img/process_fruzty/beneficio_2.png" style="width: 100%" alt="flag"/>
              </figure>
            </div>
            <p class="text-card">
              {{'BenefitAndCommercialFocus.TextCard2' | translate}}.
            </p>
          </div>
          <div class="divider"></div>
          <div class="section-flex">
            <div class="section-img">
              <figure class="figure-img">
                <img src="../../../../assets/img/process_fruzty/beneficio_3.png" style="width: 100%" alt="flag"/>
              </figure>
            </div>
            <p class="text-card">
              {{'BenefitAndCommercialFocus.TextCard3' | translate}}.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>

</app-user-dashboard>

<app-footer-home></app-footer-home>
